module.exports = __webpack_public_path__ + "img/card-brand-unknown.726f0f71.png";